import { Garage } from './garage';

export class TrafficArea {
    name: string;
    garages: Garage[];

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
